export default "/packs/images/true-adventure-new@2x~96b7dd753bfb51ceb009d67ad146ea4a.png";